"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accAdd = void 0;

var accAdd = function accAdd(number1, number2) {
  if (number1 === void 0) {
    number1 = 0;
  }

  if (number2 === void 0) {
    number2 = 0;
  }

  var m = 0;
  var n = 0;
  var d = 0;
  var arg1 = number1;
  var arg2 = number2;
  var s1 = String(arg1);
  var s2 = String(arg2);

  try {
    m += s1.split('.')[1].length;
  } catch (e) {}

  try {
    n += s2.split('.')[1].length;
  } catch (e) {}

  if (m > n) {
    d = m - n;
    arg1 = Number(s1.replace('.', ''));
    arg2 = Number(s2.replace('.', '')) * Math.pow(10, d);
  } else {
    d = n - m;
    arg1 = Number(s1.replace('.', '')) * Math.pow(10, d);
    arg2 = Number(s2.replace('.', ''));
  }

  var result = (arg1 + arg2) / Math.pow(10, Math.max(m, n));

  if (isNaN(result)) {
    result = '';
  }

  return result;
};

exports.accAdd = accAdd;